import Header from "../components/Header";
import Hero from "../components/Hero";
import DropBanner from "../components/DropBanner";
import ProductGrid from "../components/ProductGrid";
import HowItWorks from "../components/HowItWorks";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

export default function HomePage() {
    return (
        <main data-testid="home-page" className="relative">
            <Header />
            <Hero />
            <DropBanner />
            <ProductGrid />
            <HowItWorks />
            <ContactForm />
            <Footer />
        </main>
    );
}
